import icon_merchant from '../pages/main/images/icon_merchant.png'
import icon_device from '../pages/main/images/icon_device.png'
import icon_report from '../pages/main/images/icon_report.png'
import icon_setting from '../pages/main/images/icon_setting.png'
import icon_data from '../pages/main/images/icon_data.png'
import i18n from '../i18n'

const menData_ins_valid = [
    {
        name: '商户管理',
        image: icon_merchant,
        key: 'merchant',
        path: '/institution/merchantList',
    },
    {
        name: '设备管理',
        image: icon_device,
        key: 'device',
        path: '/institution/deviceList'
    },
    {
        name: '报告列表',
        image: icon_report,
        key: 'report',
        path: '/institution/reportList'
    },
    {
        name: '后台设置',
        image: icon_setting,
        key: 'setting',
        path: '/institution/setting'
    },
    {
        name: '个人设置',
        image: icon_merchant,
        key: '/changePassword',
        path: '/institution/changePassword'
    },
]

const menData_ins_invalid = [
    {
        name: '设备管理',
        image: icon_device,
        key: 'device',
        path: '/institution/deviceList'
    },
    {
        name: '报告列表',
        image: icon_report,
        key: 'report',
        path: '/institution/reportList'
    },
    {
        name: '个人设置',
        image: icon_merchant,
        key: 'changePassword',
        path: '/institution/changePassword'
    },
]

const menData_ins_silizhu = (hasStatisticsData: boolean = false) => {
    const menu = [
        {
            name: '商户管理',
            image: icon_merchant,
            key: 'merchant',
            path: '/institution/merchantList',
        },
        {
            name: '报告列表',
            image: icon_report,
            key: 'report',
            path: '/institution/reportList'
        },
        {
            name: '数据管理',
            image: icon_report,
            key: 'statistics',
            path: '/institution/statistics'
        },
        {
            name: '后台设置',
            image: icon_setting,
            key: 'setting',
            path: '/institution/setting'
        },
        {
            name: '个人设置',
            image: icon_merchant,
            key: '/changePassword',
            path: '/institution/changePassword'
        },
    ]
    if (hasStatisticsData) {
        menu.push({
            name: i18n?.t('dataManagement'),
            image: icon_data,
            key: 'exportData',
            path: `/institution/exportData`
        });
    }
    return menu;
}

const menData_mer_valid = [
    {
        name: '报告列表',
        image: icon_report,
        key: 'report',
        path: '/merchant/reportList'
    },
    {
        name: '后台设置',
        image: icon_setting,
        key: 'setting',
        path: '/merchant/setting'
    },
    {
        name: '个人设置',
        image: icon_merchant,
        key: 'changePassword',
        path: '/merchant/changePassword'
    },
]

const menData_mer_invalid = [
    {
        name: '报告列表',
        image: icon_report,
        key: 'report',
        path: '/merchant/reportList'
    },
    {
        name: '个人设置',
        image: icon_merchant,
        key: 'changePassword',
        path: '/merchant/changePassword'
    },
]

const menData_mer_silizhu = [
    {
        name: '用户列表',
        image: icon_merchant,
        key: 'examinee',
        path: '/merchant/examineeList'
    },
    {
        name: '报告列表',
        image: icon_report,
        key: 'report',
        path: '/merchant/reportList'
    },
    {
        name: '数据管理',
        image: icon_report,
        key: 'statistics',
        path: '/merchant/statistics'
    },
    {
        name: '后台设置',
        image: icon_setting,
        key: 'setting',
        path: '/merchant/setting'
    },
    {
        name: '个人设置',
        image: icon_merchant,
        key: 'changePassword',
        path: '/merchant/changePassword'
    },
]

export default function getMenuDataByName (name, hasStatisticsData: boolean = false) {
    switch(name) {
        case 'institution_invalid': return menData_ins_invalid;
        case 'institution_valid': return menData_ins_valid;
        case 'merchant_valid': return menData_mer_valid;
        case 'merchant_invalid': return menData_mer_invalid;
        case 'institution_silizhu': return menData_ins_silizhu(hasStatisticsData);
        case 'merchant_silizhu': return menData_mer_silizhu;
        default: return []
    }
}